<nb-card>
  <nb-card-body *ngIf="!showSelection">
    <div id="print-section" class="print-layout">
      <div class="container">
        <div class="item" *ngFor="let item of selectedProducts; let i = index">
          <ngx-layout-print-product
            [product]="item"
            [coverUrl]="shop.coverUrl ? shop.coverUrl : ''"
          >
          </ngx-layout-print-product>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-body *ngIf="showSelection">
    <nb-tabset fullWidth (changeTab)="changeTab($event)">
      <nb-tab tabTitle="Chọn mặt hàng">
        <ngx-view-table-products
          [products]="products"
          (onSelectedProduct)="selectedProduct($event)"
        >
        </ngx-view-table-products>
      </nb-tab>

      <nb-tab
        tabTitle="Xem trước"
        [badgeText]="selectedProducts.length"
        badgeStatus="danger"
      >
        <div id="print-section" class="print-layout">
          <div class="container">
            <div
              class="item"
              *ngFor="let item of selectedProducts; let i = index"
            >
              <ngx-layout-print-product
                [product]="item"
                [coverUrl]="shop.coverUrl ? shop.coverUrl : ''"
              >
              </ngx-layout-print-product>
            </div>
          </div>
        </div>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print-product.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="showPrinter"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>

    <button
      *ngIf="!showPrinter"
      nbButton
      hero
      shape="semi-round"
      status="warning"
      size="medium"
      (click)="selectAll()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
    >
      <nb-icon icon="checkmark-square-outline"></nb-icon>
      Chọn tất cả
    </button>

    <button
      nbButton
      outline
      shape="semi-round"
      status="danger"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
      <span>{{ "buttons.close" | translate }}</span>
    </button>
  </nb-card-footer>
</nb-card>
